import React from "react"
import Navbar from "../../../Common/Navbar"
import Footer from "../../../Common/Footer"
import Sidebar from "../../../Sidebar/Sidebar"
import ViewBalanceHistoryComp  from "./Component/ViewBalanceHistoryComp"

const ViewBalanceHistory =()=>{
    return(
        <>
        <Navbar />
        <div className="d-flex mainContentArea">
            <Sidebar />
            <ViewBalanceHistoryComp />
        </div>
        <Footer />
        </>
    )
}

export default ViewBalanceHistory